(() => {
  if (window.__enigmaShopNavigation) return;
  window.__enigmaShopNavigation = true;

  let controller;

  const filters = () => document.querySelector('[data-shop-filters-section-id]');
  const grid = () => document.querySelector('[data-shop-product-grid-section-id]');

  function sectionIds() {
    return [filters()?.dataset.shopFiltersSectionId, grid()?.dataset.shopProductGridSectionId].filter(Boolean);
  }

  function cleanUrl(url) {
    const result = new URL(url, window.location.href);
    result.searchParams.delete('sections');
    return result;
  }

  function replaceSection(current, html) {
    if (!current || !html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector(`#shopify-section-${CSS.escape(current.id.replace('shopify-section-', ''))}`);
    if (incoming) current.replaceWith(incoming);
    else current.innerHTML = html;
    return true;
  }

  async function render(url, { push = true, scroll = false } = {}) {
    const ids = sectionIds();
    if (ids.length !== 2) {
      window.location.assign(url);
      return;
    }

    controller?.abort();
    controller = new AbortController();
    document.documentElement.classList.add('shop-is-loading');
    grid()?.setAttribute('aria-busy', 'true');

    try {
      const requestUrl = new URL(url, window.location.href);
      requestUrl.searchParams.set('sections', ids.join(','));
      const response = await fetch(requestUrl, { signal: controller.signal });
      if (!response.ok) throw new Error(`Section render failed: ${response.status}`);
      const rendered = await response.json();
      const currentFilters = filters()?.closest('.shopify-section');
      const currentGrid = grid()?.closest('.shopify-section');
      if (!replaceSection(currentFilters, rendered[ids[0]]) || !replaceSection(currentGrid, rendered[ids[1]])) {
        throw new Error('Required shop sections were not returned');
      }

      grid()?.querySelector('.shop-product-grid__grid')?.classList.add('is-entering');

      const destination = cleanUrl(url);
      if (push) history.pushState({ enigmaShop: true }, '', destination);
      if (scroll) document.querySelector('#product-grid')?.scrollIntoView({ block: 'start' });
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(cleanUrl(url));
    } finally {
      document.documentElement.classList.remove('shop-is-loading');
      grid()?.setAttribute('aria-busy', 'false');
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.shop-filters__links a, .shop-product-grid__pagination a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    render(link.href, { scroll: link.closest('.shop-product-grid__pagination') !== null });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.shop-filters__sort select[name="sort_by"]');
    if (!select) return;
    const destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    render(destination);
  });

  window.addEventListener('popstate', () => render(window.location.href, { push: false, scroll: false }));
})();
